module.exports = __webpack_public_path__ + "img/yellow-square-table-3.93bfad34.png";